import React from 'react';
import ImageGalleryContainer from '../../Componant/Gallery/ImageGallery';

const ImageGallery = () => {
  return (
    <div className='page-body'>
      <ImageGalleryContainer />
    </div>
  );
};

export default ImageGallery;
